export default __webpack_public_path__ + "static/media/3.d24a9101.png";